import { theme } from '../../Assets/Styles/theme'

export const styles = {
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonLabel: {
    marginLeft: 10,
    fontSize: 16,
    color: theme.colors.primary,
  },
  actionsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
  },
  action: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  actionDescription: {
    color: '#707087',
    fontSize: 14,
    marginTop: 8,
    textAlign: 'left',
    width: '75%',
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: '#E6EAEE',
    marginTop: 32,
    marginBottom: 32,
  },
  checkboxUnchecked: {
    backgroundColor: '#DFE2E5',
    width: 18,
    height: 18,
    borderRadius: 4,
  },
  checkboxLabel: {
    color: '#011533',
    fontSize: 16,
    marginLeft: 10,
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 18,
  },
  checkbox: {
    height: 18,
  },
}
